import { useGetProductsQuery } from '~/redux/apis/product-api'
import { useAppSelector } from '~/redux/hooks'
import { CartKey, selectTutorForOtherCart, selectTutorForSelfCart, selectVideoChatCart } from '~/redux/slices/cart'
import { BookingLanguage } from '~/types/booking'

function useCartLanguage(cart?: CartKey): BookingLanguage | undefined {
  const tutorForOtherCart = useAppSelector(selectTutorForOtherCart)
  const tutorForSelfCart = useAppSelector(selectTutorForSelfCart)
  const videoChatCart = useAppSelector(selectVideoChatCart)
  switch (cart) {
    case 'tutorForOther':
      return tutorForOtherCart[0].language
    case 'tutorForSelf':
      return tutorForSelfCart.language
    case 'videoChat':
      return videoChatCart.language
    default:
      return
  }
}

export function useGetProducts(cart?: CartKey): ReturnType<typeof useGetProductsQuery> {
  const language = useCartLanguage(cart)
  return useGetProductsQuery(language ? { language } : undefined)
}
